/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Upload_Success_AllInputs */

const en_doc_upload_success_all = /** @type {(inputs: Doc_Upload_Success_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All documents uploaded successfully!`)
};

const pt_br2_doc_upload_success_all = /** @type {(inputs: Doc_Upload_Success_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os documentos foram enviados com sucesso!`)
};

/**
* | output |
* | --- |
* | "All documents uploaded successfully!" |
*
* @param {Doc_Upload_Success_AllInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_upload_success_all = /** @type {((inputs?: Doc_Upload_Success_AllInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Upload_Success_AllInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_upload_success_all(inputs)
	return pt_br2_doc_upload_success_all(inputs)
});